module.exports = __webpack_public_path__ + "img/service3-02.5f1b7e0e.png";